import { api } from "./api";

let cachedBase = null;

export async function getPublicBase() {
  if (cachedBase !== null) return cachedBase;
  try {
    const { data } = await api.get("/share-config");
    cachedBase = (data.url || "").trim() || window.location.origin;
  } catch {
    cachedBase = window.location.origin;
  }
  return cachedBase;
}
